module.exports = __webpack_public_path__ + "static/media/launay1Portrait.a4c07115.JPG";